var UploadTimeCalculator = /** @class */ (function () {
    function UploadTimeCalculator() {
        this.total = 0;
        this.totalUploaded = 0;
        this.remaining = 0;
        this.interval = null;
    }
    Object.defineProperty(UploadTimeCalculator.prototype, "timeRemaining", {
        get: function () {
            return this.remaining;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UploadTimeCalculator.prototype, "secondsRemaining", {
        get: function () {
            return parseInt(this.timeRemaining.toString());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UploadTimeCalculator.prototype, "percent", {
        get: function () {
            return ((this.totalUploaded / this.total) * 100).toFixed(2);
        },
        enumerable: false,
        configurable: true
    });
    UploadTimeCalculator.prototype.start = function () {
        var _this = this;
        var timeStarted = Date.now();
        this.interval = setInterval(function () {
            var timeElapsed = Date.now() - timeStarted;
            var uploadSpeed = _this.totalUploaded / (timeElapsed / 1000);
            _this.remaining = ((_this.total - _this.totalUploaded) / uploadSpeed);
        }, 1000);
    };
    UploadTimeCalculator.prototype.stop = function () {
        clearInterval(this.interval);
    };
    return UploadTimeCalculator;
}());
export { UploadTimeCalculator };
